import { Star, TrendingUp } from "lucide-react";
import { Vehicle } from "../../types";
import { Brand } from "../../types";
import HeroHeader from "./components/HeroHeader/HeroHeader";
import CarSection from "./components/CarSection/CarSection";
import BlogSection, { ArticleCard } from "./components/BlogSection/BlogSection";
import TrophiesSection, {
  TrophyCard,
} from "./components/TrophiesSection/TrophiesSection";
import "./styles.css";
import { Head } from "@inertiajs/react";
import homeBadges from "../../utils/homeBadges";
import Badges from "../shared/components/Badges";

type HomeIndexProps = {
  top_rated_vehicles: Vehicle[];
  trending_vehicles: Vehicle[];
  popular_brands: Brand[];
  recent_articles: ArticleCard[];
  trophy_cards: TrophyCard[];
};

const HomeIndex = (props: HomeIndexProps) => {
  const {
    top_rated_vehicles,
    trending_vehicles,
    recent_articles,
    trophy_cards,
  } = props;
  return (
    <>
      <Head title="Accueil - Review car" />
      <div className="mt-4 lg:mt-10 px-4 container mx-auto">
        <div className="flex flex-col items-center justify-center">
          <HeroHeader />
          <Badges badges={homeBadges} />
        </div>
      </div>
      <TrophiesSection vehicles={trophy_cards} />
      <div className="my-4 lg:my-10 px-4 container mx-auto">
        <div className="car-section">
          <CarSection
            title="Les plus tendances"
            vehicles={trending_vehicles}
            icon={<TrendingUp className="icon-section" />}
          />
        </div>
        <div className="car-section">
          <CarSection
            title="Les mieux notés"
            vehicles={top_rated_vehicles}
            icon={<Star className="icon-section" />}
          />
        </div>
        <BlogSection articles={recent_articles} />
      </div>
    </>
  );
};

export default HomeIndex;
